<template>
  <div class="membership_manage_width">
    <div class="pr-10">
      <v-stepper v-model="e1" alt-labels class="pb-0" :vertical="true">
        <v-stepper-header style="font-size:0.9rem; background-color: #FCFCFC;">
          <v-stepper-step :complete="e1 > 1" step="1" style="width:150px;">
            <div style="font-size: 15px; line-height: 1.5;">
              <p class="mb-1 text-center  primary--text">멤버십</p>
              <p class="mb-0 text-center  primary--text">상품/혜택 설정</p>
            </div>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="e1 > 2" step="2" style="width:150px;">
            <div style="font-size: 15px; line-height: 1.5;">
              <p class="mb-1 text-center">
                멤버십 상품페이지
              </p>
              <p class="mb-0 text-center">화면 설정</p>
            </div>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3">
            <div style="font-size: 15px; line-height: 1.5;">
              <p class="mb-1 text-center">멤버십 관리페이지</p>
              <p class="mb-0 text-center">화면 설정</p>
            </div>
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>
    </div>

    <div step="1" class="pa-0 mt-9">
      <p class="mb-3 title font-weight-bold">
        멤버십 상품/혜택 설정
      </p>
      <div>
        <MembershipSetting
          ref="MembershipSetting"
          @setDisabled="setDisabled"
        ></MembershipSetting>
      </div>
    </div>
  </div>
</template>
<script>
const MembershipSetting = () =>
  import(
    /* webpackChunkName: "MembershipSetting" */ "@/components/membership/membership_manage/MembershipSetting.vue"
  );

export default {
  data() {
    return {
      e1: 1,
    };
  },
  methods: {
    setDisabled: function(param) {
      this.disabled = false;
      this.membership_id = param.membership_id;

      if (
        confirm(
          "저장되었습니다.\n\n확인 버튼을 클릭하시면\n멤버십 상품페이지 설정 화면으로\n이동됩니다."
        )
      ) {
        this.$router.push({
          path: `/membership/${this.$store.state.mallId}/membershipReStep?membership_id=${this.membership_id}&step=2`,
        });
      } else {
        this.$router.push({
          path: `/membership/${this.$store.state.mallId}/membershipReStep?membership_id=${this.membership_id}&step=1`,
        });
      }
    },
  },
  components: {
    MembershipSetting,
  },
};
</script>
